import { useCustomClient } from '@uag/react-core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';


export const apiClient = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
});

export type ErrorType<Error> = AxiosError<Error>;

export const useCustomAppClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) => useCustomClient<T>(true, apiClient);